import ReactDOMServer from "react-dom/server.browser";
var renderToStaticMarkup = ReactDOMServer.renderToStaticMarkup;
var renderToString = async function renderToString2(app, options) {
  var readableStream = await ReactDOMServer.renderToReadableStream(app, {
    bootstrapModules: options.preloads
  });
  await readableStream.allReady;
  var reader = readableStream.getReader();
  var decoder = new TextDecoder("utf-8");
  var out = "";
  while (true) {
    var { done, value } = await reader.read();
    if (done) break;
    out += decoder.decode(value, {
      stream: true
    });
  }
  out += decoder.decode();
  return out;
};
var renderToStream = async function renderToStream2(app, options) {
  return ReactDOMServer.renderToReadableStream(app, {
    bootstrapModules: options.preloads
  });
};
export {
  renderToStaticMarkup,
  renderToStream,
  renderToString
};
//# sourceMappingURL=server-render.js.map
